import { useEffect, useState } from "react";
import styles from "./TemplateItem.module.scss";
import { setCSSGlobalVariable } from "../../../utils/functions/setCSSGlobalVariable";
import { ArrowBack } from "../../../assets/svg/ArrowBack";
import { TemplateItemList } from "./TemplateItemList/TemplateItemList";
import { useURLRouting } from "../../../utils/hooks/useURLRouting";
import { ExtraActions } from "../../../assets/svg/ExtraActions";
import {
  ExtraActionsItemProps,
  ExtraActionsMenu,
} from "../../../shared/ExtraActions/ExtraActionsMenu";
import { EditIcon } from "../../../assets/svg/EditIcon";
import { DeleteIcon } from "../../../assets/svg/DeleteIcon";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { changeShowModal } from "../../../redux/reducers/app/appReducer";
import { getTemplateFolders } from "../../../redux/reducers/ui/uiSelectors";
import { useUrlPagination } from "../../../utils/hooks/useUrlPagination";
import { Pagination } from "../../../components/Pagination/Pagination";
import { getTemplatesCount } from "../../../redux/reducers/ui/selectors/templateSelectors";
import { HelperService } from "../../../services/HelperService";

interface ITemplateItem {
  templateName: string | number;
}

export const TemplateItem = ({ templateName }: ITemplateItem) => {
  const dispatch = useAppDispatch();
  const { setTemplate } = useURLRouting();
  const [isOpen, setIsOpen] = useState(false);
  const templateFolders = useAppSelector(getTemplateFolders());

  // Templates pagination
  const PAGINATION_KEY = "templates";
  const { page, setPage } = useUrlPagination(PAGINATION_KEY, 1, false);
  const templatesCount = useAppSelector(getTemplatesCount());

  // Get current folder data
  const currentFolder = templateFolders.find(
    folder => folder.id === Number(templateName)
  );

  const handleRename = () => {
    if (!currentFolder) return;

    dispatch(
      changeShowModal({
        nameModal: "createFolderModal",
        stateModal: true,
        otherParams: {
          isEdit: true,
          folder: currentFolder,
        },
      })
    );
    setIsOpen(false);
  };

  const handleDelete = () => {
    if (!currentFolder) return;

    dispatch(
      changeShowModal({
        nameModal: "createFolderModal",
        stateModal: true,
        otherParams: {
          isDelete: true,
          folder: currentFolder,
        },
      })
    );
    setIsOpen(false);
  };

  const folderExtraActions: ExtraActionsItemProps[] = [
    {
      icon: <EditIcon />,
      label: "Rename",
      type: "update",
      onClick: handleRename,
    },
    {
      icon: <DeleteIcon />,
      label: "Delete folder",
      type: "delete",
      onClick: handleDelete,
    },
  ];

  useEffect(() => {
    setCSSGlobalVariable(
      "template-item-header",
      "height",
      "templatesItemHeaderHeight"
    );
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.header} id="template-item-header">
        <button className={styles.back} onClick={() => setTemplate("")}>
          <ArrowBack /> Back to templates
        </button>
        <div className={styles.folderActions}>
          Folder {currentFolder?.name || templateName}
          <button
            className={styles.extraActionsBtn}
            onClick={() => setIsOpen(prev => !prev)}
          >
            <ExtraActions />
          </button>
          {isOpen && (
            <div className={styles.extraActionsMenu}>
              <ExtraActionsMenu content={folderExtraActions} />
            </div>
          )}
        </div>
      </div>
      <TemplateItemList page={page} />
      <div className={styles.pagination}>
        <Pagination
          currentPage={page}
          totalPages={HelperService.getPagesCount(templatesCount)}
          onPageChange={setPage}
        />
      </div>
    </div>
  );
};
